"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addListeners = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../constants");
const helpers_1 = require("../chat/helpers");
const addMembers_1 = require("../chat/addMembers");
const addListeners = options => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    spaceId,
    listeners,
    account = null,
    signer = null,
    env = constants_1.default.ENV.PROD,
    pgpPrivateKey = null
  } = options || {};
  try {
    const group = yield (0, addMembers_1.addMembers)({
      chatId: spaceId,
      members: listeners,
      account: account,
      signer: signer,
      env: env,
      pgpPrivateKey: pgpPrivateKey
    });
    return (0, helpers_1.groupDtoToSpaceDtoV2)(group, env);
  } catch (err) {
    console.error("[Push SDK] - API  - Error - API ".concat(exports.addListeners.name, " -:  "), err);
    throw Error("[Push SDK] - API  - Error - API ".concat(exports.addListeners.name, " -: ").concat(err));
  }
});
exports.addListeners = addListeners;
//# sourceMappingURL=addListeners.js.map